import { getApplicantByOnlineUserId } from '@/api/common/applicant';
import { instanceV2, instanceWithAuth } from '@/api/instance';
import type {
  PatchPartialPlusApplicantRequestDto,
  PatchPartialPlusApplicationResponseDto,
} from '@/api/plus/applicant/applicant.dto';
import type { PlusCourse } from '@/types';

import type {
  GetPlusApplicantResponseDto,
  PatchPlusApplicantRecommenderRequestDto,
  PatchPlusApplicantRequestDto,
  PatchPlusApplicationResponseDto,
  PostPlusApplicantRequestDto,
} from './applicant.dto';

export async function getPlusApplicant(
  onlineUserId: string,
  courseKoreanName: PlusCourse,
  roundId?: string,
) {
  return await getApplicantByOnlineUserId<GetPlusApplicantResponseDto>(
    onlineUserId,
    courseKoreanName,
    roundId,
  );
}

export async function postPlusApplicant({
  body,
  courseName,
}: {
  body: PostPlusApplicantRequestDto;
  courseName: string;
}): Promise<GetPlusApplicantResponseDto> {
  return await instanceWithAuth.post<GetPlusApplicantResponseDto>(
    `/v3/apply/start`,
    {
      courseName,
      ...body,
    },
  );
}

export async function patchPlusFinalApplicant({
  body,
}: {
  body: PatchPlusApplicantRequestDto;
}) {
  return await instanceWithAuth.patch<PatchPlusApplicationResponseDto>(
    `/v3/apply/submit`,
    body,
  );
}

/**
 * @description 지원자 정보를 부분적으로 업데이트합니다.
 */
export async function patchPartialPlusApplicant(
  body: PatchPartialPlusApplicantRequestDto,
) {
  return await instanceWithAuth.patch<PatchPartialPlusApplicationResponseDto>(
    `/v3/apply/update-application`,
    body,
  );
}

export async function patchPlusApplicantRecommender({
  applicantId,
  recommendationCode,
}: PatchPlusApplicantRecommenderRequestDto) {
  await instanceV2.patch('v3/applicants/recommender', {
    applicantId,
    recommendationCode,
  });
}
